import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { Denuncia } from "../../../services/Denuncias";
import { IDenunciaCompletaDTO } from "../../../types/denuncia";
import { AxiosError } from "axios";

export const useFormComplaint = () => {
  const [data, setData] = useState<IDenunciaCompletaDTO>(
    {} as IDenunciaCompletaDTO
  );

  const { uuid } = useParams();
  const { setIsLoad } = useContextSite();

  const getData = useCallback(() => {
    setIsLoad(true);
    Denuncia.getById(uuid)
      .then(({ data }) => {
        console.log(data);
        setData(data);
      })
      .catch((error) => {
        toast.error("erro ao carregar denúncia");
      })
      .finally(() => {
        setIsLoad(false);
      });
  }, [uuid]);

  useEffect(() => {
    if (!uuid) return;
    getData();
  }, [uuid, getData]);

  const downloadImagemPorUUID = ({
    uuid,
    nome,
  }: {
    uuid: string;
    nome: string;
  }): void => {
    try {
      const baseURL = process.env.REACT_APP_API_AUTH_URL;
      if (!baseURL) {
        throw new Error(
          "A URL da API não foi definida em REACT_APP_API_AUTH_URL"
        );
      }

      setIsLoad(true);

      const url = `${baseURL}/arquivos/${uuid}/download/`;

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", nome);

      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Ocorreu um erro ao tentar iniciar o download:", error);

      alert("Não foi possível iniciar o download do arquivo.");
    } finally {
      setIsLoad(false);
    }
  };

  return {
    data,
    downloadImagemPorUUID,
  };
};
